import { Injectable, signal } from '@angular/core';

export interface AccountTypeChangeRequest {
  id: number;
  currentRole?: number | null;
  displayName?: string | null;
  bio?: string | null;
  onChanged?: () => void | Promise<void>;
}

export type AccountTypeChangeOpenOptions = Omit<AccountTypeChangeRequest, 'id'>;

@Injectable({
  providedIn: 'root',
})
export class AccountTypeChangeService {
  private nextRequestId = 1;
  private readonly requestSignal = signal<AccountTypeChangeRequest | null>(null);

  readonly request = this.requestSignal.asReadonly();

  open(options: AccountTypeChangeOpenOptions = {}): void {
    this.requestSignal.set({
      id: this.nextRequestId,
      ...options,
    });
    this.nextRequestId += 1;
  }

  close(): void {
    this.requestSignal.set(null);
  }
}
